import { getFeatureFlag } from './feature-flags-storage';

export const isSyncEnvironmentEnabled = () => getFeatureFlag('syncEnvironment');
